<template>
  <div class="block-m">
    <div class="block-m__letter letter letter-red">
      М.
    </div>
    <div class="block-m__image">
      <img src="../assets/img/block-m-1.jpg" alt="">
    </div>
    <div class="block-m__title">Метрополь</div>
        <div class="block-m__text text text-white">
          <p>После периода эмиграции на Родину Вертинский вернулся с огромным трудом. Не один год ему потребовалось потратить на то, чтобы оформить все документы и добиться разрешения воротиться в СССР. <br>В процессе одной из этих попыток Вертинский пишет Молотову: «Жить вдали от Родины в момент, когда она обливается кровью, и быть бессильным ей помочь — самое ужасное».</p>
          <p>Осенью 1943 года Вертинский со своей женой Лидией Владимировной, которая была моложе него на 34 года, <br>и со своей дочерью Марианной приехал в Москву. Их первым адресом стала легендарная пятизвёздочная гостиница «Метрополь».</p>
        </div>
    <div class="block-m__content">
      <div class="block-m__left">
        <div class="block-m__row">
        </div>
        <div class="block-m__quote">„Где-то там: наверху всё ещё делают вид, что я не вернулся, что меня нет в стране. <br>Обо мне не пишути не говорят ни слова. Газетчики и журналисты говорят: <br><span>„Нет сигнала“</span>. <br>Вероятно, его и не будет. <br><span>А  между тем Я есть! “</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockMm'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-m__image
      transform: scale(3.4)
      margin-left: 28.5vw
      &:after
        background-image: url(../assets/img/block-m-el-m.png)
        top: 8.2vw
        left: 8.4vw
    .block-m__left .block-m__quote
      font-size: vwm(50px)
      line-height: vwm(40px)
      text-align: center
      width: 93vw
      margin: auto
      margin-top: vwm(11px)
    .block-m__content
      width: 100%
      display: block
    .block-m__letter
      margin-left: vwm(185px)
      margin-top: vwm(24px)
      width: vwm(182px)
      position: relative
      z-index: 200
      padding-left: vwm(13px)
    .block-m__text
      margin-left: vwm(16px)
      width: 90vw
      br
        display: none
      p
        margin-bottom: vwm(25px)
    .block-m__title
      font-size: vwm(60px)
      margin-top: vwm(110px)
      margin-left: vwm(19px)
</style>
